module.exports = __webpack_public_path__ + "img/communication.f57a18aa.jpg";